const getVerseIdsFromPassageId = passageId => {
  let [startId, endId] = passageId.split("-");
  endId = endId || startId;
  const verseIds = [];
  const [startBook, startChapter, startVerse] = startId.split(".");
  const [endBook, endChapter, endVerse] = endId.split(".");
  const maxVerse =
    startBook === endBook && startChapter === endChapter ? endVerse : 150;

  for (let verseNumber = startVerse; verseNumber <= maxVerse; verseNumber++) {
    verseIds.push([startBook, startChapter, verseNumber].join("."));
  }
  return verseIds;
};

export default getVerseIdsFromPassageId;
